function Points() {
  return (
    <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.6875 0.46875V20.7812H16.3125V5.62012L11.1611 0.46875H0.6875ZM2.25 2.03125H10.0625V6.71875H14.75V19.2188H2.25V2.03125ZM11.625 3.12988L13.6514 5.15625H11.625V3.12988ZM3.8125 8.28125V9.84375H13.1875V8.28125H3.8125ZM3.8125 12.1875V13.75H9.28125V12.1875H3.8125ZM10.8438 12.1875V13.75H13.1875V12.1875H10.8438ZM3.8125 15.3125V16.875H9.28125V15.3125H3.8125ZM10.8438 15.3125V16.875H13.1875V15.3125H10.8438Z" fill="currentColor" />
    </svg>
  )
}

export default Points